import "./ExplainTurtle.css"; // nhớ tạo file CSS bên dưới

const defaultSteps = [
  {
    title: "Organize",
    body: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor.",
  },
  {
    title: "Strategize",
    body: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor.",
  },
  {
    title: "Delegate",
    body: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor.",
  },
];

export default function RumiHelpPanel({
  headingScript1 = "Giới thiệu",
  headingScript2 = "Mascot Rùa Rumi",
  headingKicker = "HERE'",
  intro = "Trong thế giới dịu dàng của tã bỉm Rumi, có một người bạn nhỏ mang tên Rùa Rumi: bé rùa đội chiếc mai xanh, khoác đôi cánh trắng, nằm yên trên đám mây bồng bềnh. ",
  ctaText = "Learn More",
  steps = defaultSteps,
  className = "",
}) {
  return (
    <section className={`rhp ${className}`}>
      <div className="rhp__media" aria-hidden>
        <img src="/images/about/turtle.png" alt="turtle" className="turtle" />
      </div>

      {/* Bên phải chia 2 cột: intro + CTA bên trái, steps bên phải */}
      <div className="rhp__panel">
        <div className="rhp__grid">
          <div className="rhp__lead">
            <h2 className="rhp__script">{headingScript1}</h2>
            <h2 className="rhp__script">{headingScript2}</h2>
            <p className="rhp__kicker">{headingKicker}</p>

            <p className="rhp__intro">{intro}</p>
            <div className="text-center">
              <img
                src="/images/child1.jpg"
                alt="rumi turtle"
                className="w-100"
              />
            </div>
            <p className="rhp__intro">
              Rùa Rumi là hiện thân của tình yêu, sự chở che và giấc ngủ êm ái,
              được sinh ra từ trái tim của thương hiệu Việt, dành trọn cho những
              thiên thần nhỏ của đất nước mình.
            </p>
          </div>

          <ul className="rhp__steps">
            {steps.map((s, i) => (
              <li key={i} className="rhp__step">
                <div className="rhp__num" aria-hidden>
                  {i + 1}
                </div>
                <div className="rhp__text">
                  <h3 className="rhp__stepTitle">{s.title}</h3>
                  <p className="rhp__stepBody">{s.body}</p>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
